import { render, staticRenderFns } from "./GetAttributesList.vue?vue&type=template&id=5de3ac4c&"
import script from "./GetAttributesList.vue?vue&type=script&lang=js&"
export * from "./GetAttributesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports